module.exports = "<div class=\"fourohfour\">\n  <div class=\"container\">\n    <h1>Something went wrong</h1>\n    <p>{{ message }}</p>\n    <button ng-click=\"browseVenues()\" href=\"#\" class=\"btn btn-default\">Browse Venues</button>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/errorServer/errorServer.html
// module id = 815
// module chunks = 1